import React, { useState, useEffect } from 'react';

import DashboardHomeAdmin from '../components/DashboardHomeAdmin'; // Your existing Dashboard component
import UnifiedAddEmployeeModal from '../components/UnifiedAddEmployeeModal';
import SetupWizard from '../components/wizard/SetupWizard';
import api from '../utils/api';
import { toast } from 'react-hot-toast';

const AdminDashboard = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showSetupWizard, setShowSetupWizard] = useState(false);
    const [companyData, setCompanyData] = useState(null);

    useEffect(() => {
        fetchCompanyData();
        checkSetupStatus();
    }, []);

    const fetchCompanyData = async () => {
        try {
            const response = await api.get('/auth/profile');
            setCompanyData(response.data.company);
        } catch (error) {
            console.error('Error fetching company data:', error);
        }
    };

    const checkSetupStatus = async () => {
        try {
            // Check if any roles or teams exist
            const rolesRes = await api.get('/employees/roles');
            const teamsRes = await api.get('/teams'); // Assuming /teams exists and returns array

            const hasRoles = rolesRes.data.roles && rolesRes.data.roles.length > 0;
            const hasTeams = teamsRes.data.teams && teamsRes.data.teams.length > 0;

            // Trigger wizard if NO roles (other than system default??) or NO teams.
            // But wait, existing logic may already populate some defaults?
            // If completely empty custom roles, show wizard.

            if (!hasRoles && !hasTeams) {
                setShowSetupWizard(true);
            }
        } catch (error) {
            console.error('Error checking setup status:', error);
        }
    };

    const handleAddEmployee = () => {
        toast.success('Employee invitation sent! 🎉', {
            duration: 4000,
            icon: '✉️',
        });
        setShowAddModal(false);
        // Optional: refresh dashboard stats if needed
    };

    const handleWizardComplete = () => {
        setShowSetupWizard(false);
        // Refresh data potentially
        window.location.reload(); // Simple refresh to update state everywhere
    };

    return (
        <div className="min-h-screen bg-background">

            <DashboardHomeAdmin
                sidebarCollapsed={sidebarCollapsed}
                onMenuClick={() => setMobileMenuOpen(true)}
                onAddEmployee={() => setShowAddModal(true)} // Opens modal directly
            />

            {/* Add Employee Modal - unified modal for all employee types */}
            <UnifiedAddEmployeeModal
                isOpen={showAddModal}
                onClose={() => setShowAddModal(false)}
                onSuccess={handleAddEmployee}
                companyData={companyData}
            />

            {/* First Time Setup Wizard */}
            <SetupWizard
                isOpen={showSetupWizard}
                onClose={() => setShowSetupWizard(false)} // User can dismiss
                onComplete={handleWizardComplete}
            />
        </div>
    );
};

export default AdminDashboard;